module.exports = __webpack_public_path__ + "01_glasses_blue.d1268a9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/01_glasses_blue.png
// module id = rj/e
// module chunks = 0